import {
  Z_INDEX_APP_ALERT,
  Z_INDEX_HEADER,
  Z_INDEX_MODAL,
} from '../../constants/zIndex';

// Function to set CSS custom properties from TypeScript variables
export const setCSSVariables = () => {
  const root = document.documentElement;
  root.style.setProperty('--z-index-header', Z_INDEX_HEADER.toString());
  root.style.setProperty('--z-index-app-alert', Z_INDEX_APP_ALERT.toString());
  root.style.setProperty('--z-index-modal', Z_INDEX_MODAL.toString());
};
